import api from './api';

const statsService = {
  /**
   * Obtener dashboard completo con todas las métricas principales
   */
  async getDashboard() {
    try {
      const response = await api.get('/stats/dashboard');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener dashboard'
      };
    }
  },

  /**
   * Obtener resumen por período personalizado
   * @param {Object} params - { desde: 'YYYY-MM-DD', hasta: 'YYYY-MM-DD' }
   */
  async getResumen(params = {}) {
    try {
      const response = await api.get('/stats/resumen', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener resumen'
      };
    }
  },

  /**
   * Obtener estadísticas por período predefinido
   * @param {string} tipo - 'dia', 'semana', 'mes', 'año'
   */
  async getPeriodo(tipo = 'mes') {
    try {
      const response = await api.get('/stats/periodos', { 
        params: { tipo } 
      });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener estadísticas del período'
      };
    }
  },

  /**
   * Obtener ganancias por producto
   * @param {Object} params - { desde, hasta, limit }
   */
  async getPorProducto(params = {}) {
    try {
      const response = await api.get('/stats/por-producto', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener ganancias por producto'
      };
    }
  },

  /**
   * Obtener ganancias por categoría
   * @param {Object} params - { desde, hasta }
   */
  async getPorCategoria(params = {}) {
    try {
      const response = await api.get('/stats/por-categoria', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener ganancias por categoría'
      };
    }
  },

  /**
   * Obtener estadísticas por vendedor
   * @param {Object} params - { desde, hasta }
   */
  async getPorVendedor(params = {}) {
    try {
      const response = await api.get('/stats/por-vendedor', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener estadísticas por vendedor'
      };
    }
  },

  /**
   * Obtener comparativo entre períodos
   * @param {string} tipo - 'dia', 'semana', 'mes', 'año'
   */
  async getComparativo(tipo = 'mes') {
    try {
      const response = await api.get('/stats/comparativo', { 
        params: { tipo } 
      });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener comparativo'
      };
    }
  }
};

export default statsService;


